import { classes, st } from './DragHandle.st.css';
import React from 'react';
import {
  DragAndDropLarge,
  DragAndDropSmall,
} from '@wix/wix-ui-icons-common/system';
import Tooltip from '../Tooltip';
import { DragHandleInternalProps } from './DragHandle.types';

export function DragHandle(props: DragHandleInternalProps) {
  const {
    dataHook,
    domRef,
    dragging,
    disabled,
    'aria-label': ariaLabel,
    'aria-describedby': ariaDescribedBy,
    tooltipContent,
    tooltipProps,
    dragHandleSize,
    ...rest
  } = props;

  const dragHandleIcon =
    dragHandleSize === 'small' ? (
      <DragAndDropSmall data-hook="dnd" />
    ) : (
      <DragAndDropLarge data-hook="dnd" />
    );

  return (
    <Tooltip
      dataHook={dataHook}
      disabled={!tooltipContent}
      content={tooltipContent}
      appendTo="window"
      {...tooltipProps}
      aria-describedby={tooltipContent ? undefined : ariaDescribedBy}
    >
      <div
        data-hook="drag-handle-button"
        data-disabled={!!disabled}
        aria-label={tooltipContent || ariaLabel}
        aria-describedby={ariaDescribedBy}
        ref={domRef}
        {...rest}
        role="button"
        className={st(classes.root, {
          disabled,
          dragging,
        })}
      >
        {dragHandleIcon}
      </div>
    </Tooltip>
  );
}
